// Vuex floating window store module

const state = {
  globalVisible : true,
  windows       : []
}

const getters = {
  getWindowData : state => name => state.windows.find(windowData => windowData.name === name),
  globalVisible : state => state.globalVisible
}

const mutations = {
  addWindow (state, data) {
    state.windows.push({
      name    : data.name,
      top     : data.top,
      left    : data.left,
      visible : data.visible,
      indexZ  : 500
    })
  },
  moveWindow (state, data) {
    state.windows.some(windowData => {
      if (data.name === windowData.name) {
        windowData.top  = data.top
        windowData.left = data.left
        return true
      }
    })
  },
  toggelGlobalVisible (state) {
    state.globalVisible = !state.globalVisible
  },
  toggleVisible (state, name) {
    state.windows.some(windowData => {
      if (name === windowData.name) {
        windowData.visible = !windowData.visible
      }
    })
  },
  windowActive (state, name) {
    state.windows.map(windowData => {
      if (windowData.name === name) {
        windowData.indexZ = 600
      } else {
        windowData.indexZ = 500
      }
    })
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/components/floatingWindow/store/index.js